<template>
  <v-container>
    <v-row>
      <Tabs
        :tabs="tabs"
        :level="2"
        :tab-lv1-index="tabLv1Index"
        :tabs-lv1-count="tabsLv1Count"
      />
    </v-row>
  </v-container>
</template>

<script>
import Tabs from '../../../components/Reporting/Tabs';
import EstimatedIdealExamVolume from './EstimatedIdealExamVolume';
import Hygiene from './Hygiene';
import Overview from './Overview';

export default {
  name: 'ClinicReporting',
  components: {
    Tabs,
    Overview,
  },
  props: ['tabLv1Index', 'tabsLv1Count'],
  data() {
    return {
      pageName: 'Clinic Overview',
      tabs: [
        { label: 'Overview', section: Overview },
        { label: 'Estimated Ideal Exam Volume', section: EstimatedIdealExamVolume },
        { label: 'Hygiene', section: Hygiene },
      ],
    };
  },
};
</script>
